import * as React from "react";
import { forwardRef } from "react";
const SvgFileIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m22 8v-5.37l5.46 6.37h-4.46a1 1 0 0 1 -1-1zm1 3a3 3 0 0 1 -3-3v-6h-13a3 3 0 0 0 -3 3v22a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-16z" }));
const ForwardRef = forwardRef(SvgFileIcon);
export default ForwardRef;
